import { QueryType } from '@/app/types/types'
import { apiClient } from '..'

const createAssessmentTemplateRequest = async (data: QueryType) => {
    return apiClient().post(`/api/assessment/templates`, data)
}

const getAllAssessmentTemplatesRequest = async (query: QueryType) => {
    return apiClient().get(`/api/assessment/templates`, {
        params: query,
    })
}

const updateAssessmentTemplateRequest = async (id: number, data: QueryType) => {
    return apiClient().put(`/api/assessment/templates/${id}`, data)
}

const deleteAssessmentTemplateRequest = async (id: number, data: QueryType) => {
    return apiClient().delete(`/api/assessment/templates/${id}`, {
        params: data,
    })
}

const createAssessmentParamRequest = async (data: any) => {
    return apiClient().post(`/api/assessment/params`, data)
}

const getOneAssessmentParamRequest = async (id: number, params: QueryType) => {
    return apiClient().get(`/api/assessment/params/${id}`, {
        params,
    })
}

const getAllAssessmentParamsRequest = async (query: QueryType) => {
    return apiClient().get(`/api/assessment/params`, {
        params: query,
    })
}

const deleteAssessmentParamRequest = async (id: number, params: QueryType) => {
    return apiClient().delete(`/api/assessment/params/${id}`, {
        params: params,
    })
}

const getOneAssessmentTemplateRequest = async (id: number, params: QueryType) => {
    return apiClient().get(`/api/assessment/templates/${id}`, {
        params,
    })
}

const updateAssessmentParamRequest = async (id: number, data: QueryType) => {
    return apiClient().put(`/api/assessment/params/${id}`, data)
}

export {
    createAssessmentTemplateRequest,
    createAssessmentParamRequest,
    getAllAssessmentTemplatesRequest,
    updateAssessmentTemplateRequest,
    deleteAssessmentTemplateRequest,
    getAllAssessmentParamsRequest,
    deleteAssessmentParamRequest,
    getOneAssessmentTemplateRequest,
    updateAssessmentParamRequest,
    getOneAssessmentParamRequest,
}
